<template>
    <div>
        <div class="cart-mini__toggle-basket" v-if="user.multicart == 'Y'">{{basket.basketSelect.name}} <a @click.stop="selectBasket" href="javascript:void(0)" class="profile-mini__link">сменить</a></div>

        <transition name="modal">
            <div class="modal-mask" v-if="isModalVisible">
                <div class="modal-wrapper">
                    <div class="modal-container --select-cart">
                        <div class="modal-header">
                            <h3>Выбор корзины</h3>
                            <button type="button" class="btn-close-modal" @click="close()">×</button>
                        </div>
                        <div class="modal-body">
                            <div  class="container">
                                <table>
                                    <tr v-for="item in basket.baskets">
                                        <td>{{item.name}}</td>
                                        <td>{{item.q}} шт. </td>
                                        <td>{{item.sum}} Р.</td>
                                        <td><a href="#" @click="send(item.id)">Выбрать</a></td>
                                    </tr>
                                </table>
                            </div>
                        </div>

                        <div class="modal-footer">
                            <a class="modal-default-button" @click="close()">
                                Закрыть
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
    import axios from "axios";
    export default {
        name: "SelectCart",
        data: function () {
            return {
                basket: this.$ls.get('basket')
                    ??
                    {
                        count: 0,
                        price: 0,
                    },
                user: this.$ls.get('user') ?? null,
                waitingList: this.$ls.get('waiting') ?? null,
                curPage: window.btoa(this.$route.path),
                notifyIds: [],
                groupNotify: 'custom-template',
                isModalVisible:false,
            }
        },
        methods: {
            selectBasket: function (event) {
                console.log(this.user);
                this.isModalVisible = true;
                $(".header__cart-mini").addClass("active");
                return false;
            },
            close() {
                this.isModalVisible = false;
                $(".header__cart-mini").removeClass("active");
            },
            send(id) {
                $(".header__cart-mini").removeClass("active");
                this.isModalVisible = false;
                axios.post(
                    '/bitrix/services/main/ajax.php?mode=class&c=custom:api.v1.cart&action=selectCart',
                    {
                        'id': id,
                    },
                    {
                        headers: {
                            'content-type': 'application/json; charset=utf8',
                            'X-Requested-With': 'XMLHttpRequest',
                            'X-Bitrix-Csrf-Token':BX.message('bitrix_sessid'),
                        }
                    }
                ).then(function () {
                    window.location.reload();
                });


            },
        },

    }
</script>